export default __webpack_public_path__ + "static/media/egovlogo-removebg-preview.a40000d4.png";